import { MdErrorOutline } from "react-icons/md";

/*
  Abas de formulário dentro de um modal.

  Três coisas que as versões anteriores não faziam:

  1. **Ficam FIXAS no topo.** O formulário de cliente tem seis abas e rola
     bastante; as abas subiam junto com o conteúdo e, no meio da aba de
     Horários, não havia como trocar sem rolar de volta.

  2. **Mostram em qual aba está o erro.** Num formulário multi-aba, clicar em
     "Salvar" e não acontecer nada porque um campo obrigatório está em OUTRA
     aba é a frustração clássica — a validação dispara, a mensagem aparece
     numa aba que você não está vendo, e a tela parece travada.

  3. **São um controle segmentado**, não uma fileira de pílulas soltas. A
     pílula isolada se lê como filtro; o segmento com fundo contínuo se lê
     como "um destes, e estou neste".
*/

const FormTabs = ({ tabs, activeTab, onChange, errorsByTab = {} }) => (
  <div className="sticky top-0 z-10 -mx-5 -mt-4 mb-4 border-b border-slate-100 bg-white/95 px-5 py-3 backdrop-blur">
    <div className="overflow-x-auto">
      <div className="inline-flex min-w-full items-center gap-1 rounded-xl bg-slate-100 p-1 sm:min-w-0">
        {tabs.map((tab) => {
          const ativo = activeTab === tab.key;
          const temErro = Boolean(errorsByTab[tab.key]);

          return (
            <button
              key={tab.key}
              type="button"
              onClick={() => onChange(tab.key)}
              aria-current={ativo ? "page" : undefined}
              className={`relative flex flex-1 items-center justify-center gap-1.5 whitespace-nowrap rounded-lg px-3 py-1.5 text-xs font-semibold transition ${
                ativo
                  ? "bg-white text-slate-900 shadow-sm"
                  : "text-slate-500 hover:text-slate-800"
              }`}
            >
              {tab.icon ? <tab.icon size={14} /> : null}
              {tab.label}

              {temErro ? (
                <MdErrorOutline
                  size={14}
                  className="text-rose-500"
                  title="Há campo obrigatório pendente nesta aba"
                />
              ) : null}
            </button>
          );
        })}
      </div>
    </div>
  </div>
);

export default FormTabs;
